import FormData from 'form-data';

import {
    FIELDS,
    TYPES,
} from 'desktop/pages/checkout/store/sagas/deliveryStep/saveCustomerAddressSaga/constants';

import {AddressesType} from '../types/addressType';

/**
 * Appends fields values to FormData instance and returns it
 * @param {AddressesType} addresses - Received addresses
 * @return {FormData} - Returned form data
 */
export const makeFormAddressData = (addresses: AddressesType): FormData => {
    const formData = new FormData();

    TYPES.forEach(type => {
        const address = addresses[type as keyof AddressesType];
        FIELDS.forEach(([target, field]) => {
            formData.append(`${type}${target}`, address[field] || '');
        });
    });

    return formData;
};
